<template>
    <div id="productTaskAddProduct" class="background-white" v-loading="loading"> <!-- 商品任务-编辑任务-添加商品 -->
        <el-tabs v-model="activeName">
            <el-tab-pane label="账号选择" name="account">
                <ul class="flex">
                    <li class="flex pl20">
                        <span class="pr10">账号</span>
                        <div>
                            <el-input size="mini" v-model="search.account" @keyup.enter.native="pageNo = 1, getList()" style="width: 220px;" placeholder="请输入" clearable></el-input>
                        </div>
                    </li>
                    <li class="flex pl20" v-if="isSearch!==2">
                        <span class="pr10">企业名称</span>
                        <div>
                            <el-input size="mini" v-model="search.companyNameLike" @keyup.enter.native="pageNo = 1, getList()" style="width: 220px;" placeholder="请输入" clearable></el-input>
                        </div>
                    </li>
                    <li class="flex pl20">
                        <el-button type="primary" size="mini" @click="pageNo = 1, getList()">搜索</el-button>
                        <span class="ml10">分组名称：{{ids[0].name}}</span>
                    </li>
                </ul>
                <div class="pl20 pt20 pr20 pb10 color-606266">
                    <el-table :data="list" ref="tab" size="mini" row-key="productCode" @selection-change="changeCheckId" height="calc(70vh - 205px)">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column label="账号" prop="mobile"></el-table-column>
                        <el-table-column label="地区">
                            <template slot-scope="scope">
                                {{scope.row.province+scope.row.city+scope.row.district}}
                            </template>
                        </el-table-column>
                        <el-table-column label="企业名称" prop="companyName"></el-table-column>
                        <el-table-column label="审核状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.authenticationStatus==='INIT'">待认证</span>
                                <span v-else-if="scope.row.authenticationStatus==='AUDITING'">认证审核中</span>
                                <span v-else-if="scope.row.authenticationStatus==='PASS'">认证通过</span>
                                <span v-else-if="scope.row.authenticationStatus==='FAILED'">认证失败</span>
                                <span v-else>已过期</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==='ENABLED'">启用</span>
                                <span v-else>禁用</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="pr20 pb10 background-white text-right pages" @size-change="pageSizeChange" @current-change="pageNoChange" :current-page="pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </el-tab-pane>
            <el-tab-pane label="批量导入" name="import" v-if="isSearch!==2">
                <div class="flex p20" style="height: calc(70vh - 105px);">
                    <div class="f2 pr20">
                        <p>批量设置账号分组</p>
                        <el-input type="textarea" class="mt10" :autosize="{ minRows: 4, maxRows: 10}" v-model.trim="codeStr" placeholder="输入账号，以逗号隔开，例如：1190208,1236483" clearable></el-input>
                    </div>
                    <div class="f1">
                        <p>说明：</p>
                        <p>1、批量设置账号分组，一次最多可导入200个</p>
                        <p>2、请以英文逗号隔开账号编码；</p>
                        <p>3、系统将自动识别账号编码并设置分组，超过200个或不符合规则的账号编码将导入失败，导入后请检查确认</p>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
        <div class="btns pr20 pt10 pb10 text-right">
            <el-button type="primary" size="mini" plain @click="close()">取消</el-button>
            <el-button type="primary" size="mini" @click="success()">确定</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'accountSet', // 账号设置分组
    props: ['ids','isSearch'],
    data () {
        return {
            loading: false,
            activeName: 'account', // account-账号选择 import-批量导入
            checkList: [], // 已选中的商品
            search: { // 搜索数据
                account: '', // 账号
                companyNameLike: '', // 企业名称
            },
            isOne: true,
            typeList: [], // 商品分类列表
            list: [], // 搜索的商品列表
            pageNo: 1,
            pageSize: 10,
            total: 0,
            codeStr: '', // 商品编码字符串
            checkId: [], // 勾选的商品
        }
    },
    methods: {
        // 修改每页个数
        pageSizeChange(val) {
            this.pageSize = val
            this.pageNo = 1
            this.getList()
        },
        // 修改页码
        pageNoChange(val) {
            this.pageNo = val
            this.getList()
        },
        // 获取商品列表
        getList() {
            let options = {
                mobileLike: this.search.account, // 账号(手机号)
                companyNameLike: this.search.companyNameLike, // 企业名称
                groupId: (this.isSearch === 2 ? this.ids[0].id : null),
                page: this.pageNo-1,
                size: this.pageSize
            }
            this.loading = true
            this.$http('post', '/admin/user/page', {}, options, (status, rsp) => {
                this.loading = false
                if (status) {
                    if(!!rsp.content && rsp.content.length > 0) {
                        this.list = rsp.content;
                    }else {
                        this.list = [];
                    }
                    if (this.ids.length > 0 && this.isOne) {
                        this.ids.forEach(el => {
                            this.$refs.tab.toggleRowSelection(el, true)
                        })
                        this.isOne = false
                    }
                    this.total = rsp.totalCount;
                }
            })
        },
        // tab切换选中商品
        changeCheckId(e) {
            this.checkId = e
        },
        //移出
        removeVip () {
            if (this.checkId.length === 0) {
                this.error('请选择账号')
                return
            }
            this.$emit('success', this.checkId)
        },
        // 关闭
        close() {
            this.$emit('close')
        },
        // 保存
        success() {
            if (this.activeName === 'account') {
                if (this.checkId.length === 0) {
                    this.error('请选择账号')
                    return
                }
                if (this.checkId.length > 200) {
                    this.error('每个分组最多添加200个账号')
                    return
                }
                this.$emit('success', this.checkId)
            } else if (this.activeName === 'import') {
                if (this.codeStr === '') {
                    this.error('请输入正确的账号编码')
                    return
                }
                this.codeStr = this.codeStr.replace(/，/g, ',')
                let ids = this.codeStr.split(',')
                console.log('codeStr',this.codeStr);
                if (ids.length === 0) {
                    this.error('请输入正确的账号编码')
                    return
                }
                this.$emit('success', ids.join(','))
                // this.loading = true
                // this.$http('post', '/report/task/phone/import/product', options, {}, (status, rsp) => {
                //     this.loading = false
                //     if (status) {
                //         if (rsp.data.length === 0) {
                //             this.error('请输入正确的账号编码')
                //         } else {
                //             this.$alert('已成功设置'+ rsp.data.length +'个', '', {
                //                 confirmButtonText: '确定',
                //                 callback: action => {
                //                     this.$emit('success', rsp.data)
                //                 }
                //             })
                //         }
                //     }
                // })
            }
        }
    },
    mounted () {
        // this.checkList = this.ids
        this.getList()
        // if (!this.isSearch) {
        // } else {
        //     this.ids.forEach((item)=>{
        //         item.isShow = true;
        //         this.list.push(item)
        //     })
        // }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#productTaskAddProduct{height: 70vh;overflow-y: auto; line-height: 28px;}
#productTaskAddProduct >>> .el-tabs--top .el-tabs__item.is-top:nth-child(2){padding: 0 20px;}
#productTaskAddProduct >>> .el-tabs__active-bar{transform: translateX(20px);}
</style>



// WEBPACK FOOTER //
// src/views/user/groupManage/batchAdd.vue